import { Inject } from '@odinjs/odin';

import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { MapAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { MapViewAliases as Alliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.MAP_VIEW })
export default class MapViewController extends BaseController {

  @Inject(Alliases.MAP)
  private map: MapAPI;

  @OnMount(Alliases.PANEL_MAP)
  ouMount(): void {
    const nrSeqProvider = this.context.get('nrSeqProvider');

    HttpService.get<string>(ENDPOINTS.GET.MAP_ADDRESS, { nrSeqProvider })
      .then(({ body }) => {
        if (body) {
          if (body.endsWith('q=')) {
            body = body.replace('q=', 'q=brasil');
          }
          this.map.setProviderUrl(body);
        }
      }).finally(() => this.map.setLoading(false));
  }
}
